import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../shared/services/auth.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {ParamService} from '../../../shared/services/param.service';
import {properties} from '../../../../environments/properties';

declare var $: any;



@Component({
    selector: 'app-points-score-card',
    templateUrl: './points-score-card.component.html',
    styleUrls: ['./points-score-card.component.scss']
})
export class PointsScoreCardComponent implements OnInit, AfterViewInit {

    @Input() currentEnvironment: string;
    @Input() userInfo: any;
    @Input() appHostURL: any;
    @Input() banner: any;
    public isLoggedInTokenValid = false;
    public loading = true;
    public linkBannerForU: string;
    public linkFreshPass: string;
    public hideFreshPassBanner: string;
    public rewardsBalanceCopy: string;
    public freshPassNoExpiryCopy: string;
    public nextRewardCopy: string;
    public showHelpingButtons = true;
    public bannerForUOpenNewTab: string;
    public selectedBanner: string;
    public freshPassOpenNewTab: string;
    @Input() cashRewardsFlow: boolean;
    @Input() pointScoreCardFlow: boolean;
    public AB = window['AB'];
    showProgressBar = true;
    freshPassUser = false;
    suspendedFreshPassUser = false;
    balanceDisplay: any;
    rewardsPointsValueDetailsDisplay: any;
    rewardsPointsDateDetailsDisplay: any;
    showScoreCard = false;
    showPointsGallery = false;
    rewardsResponseObj: any;
    isFuelSiteBanner: boolean = true;
    public showCashReward: boolean;
    isRewardsTabActive = false;
    ismoreWaysToUseActive = false;
    isBoostYourPointsActive = false;
    isPointsForServicesActive = false;
    showBoostPointsHeading = false;
    popupText = 'Check out the new ways to earn and use your Points!';
    analyticsAutoCash = 'off';
    @ViewChild('tabsList') tabsList: ElementRef;
    constructor(public authService: AuthService,
                private _rewardSummaryService: RewardsSummaryService,
                private paramService: ParamService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.isPointsForServicesActive = properties.rewardsConfig.pointsForServicesBanner[this.banner];
        this.isFuelSiteBanner = properties.rewardsConfig.fuelSiteBanner[this.banner];
        this.showCashReward = this.cashRewardsFlow;
        this.linkBannerForU = '/foru/program-details.html';
        this.linkFreshPass = '/lp/subscriptions-delivery.html';
        this.hideFreshPassBanner = 'false';
        this.rewardsBalanceCopy = 'Rewards Balance';
        this.freshPassNoExpiryCopy = 'Rewards don’t expire with <a href="/lp/subscriptions-delivery.html" target="_blank">FreshPass</a><sup>TM</sup>';
        this.nextRewardCopy = 'Rewards Balance';
        this.bannerForUOpenNewTab = '_blank';
        this.selectedBanner = '';
        this.freshPassOpenNewTab = '/freshpass/manage/subscribe';

        this.getUserInfo();
    }

    ngAfterViewInit(): void{
        if(this.isPointsForServicesActive) {
            if (!localStorage.getItem('showCoachMarkRewards')) {
                setTimeout(() => {
                  if (localStorage.getItem('abRewards') && JSON.parse(localStorage.getItem('abRewards')).cashOffer) {
                        const cashReward = JSON.parse(localStorage.getItem('abRewards')).cashOffer;
                        if (!cashReward || cashReward.length === 0) {
                         $('.coach-mark-container').addClass('custom-coach-mark');
                      }
                   }
                    $('.coach-mark-container').removeClass('mask');
                    if (window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].setUserMessageEvents(`${this.popupText?.replace(/[.,!]/g,'').replace(/ /g, '-')}|autocash-${this.analyticsAutoCash}`);
                    }
                    setTimeout(() => {
                       localStorage.setItem('showCoachMarkRewards', 'false');
                       $('.coach-mark-container').addClass('mask');
                       $('.coach-mark-container').removeClass('custom-coach-mark');
                    }, 15000);
                }, 2000);
            }
        }
    }

    closeCoachMark() {
        localStorage.setItem('showCoachMarkRewards', 'false');
        $('.coach-mark-container').addClass('mask');
    }

    getUserInfo() {
        if (this.userInfo) {
            if (this.authService.isTokenValidForSession(this.userInfo)) {
                this.selectedBanner = this.userInfo.banner;
                this.isLoggedInTokenValid = true;
                this.initSubscribe();
                this.initRewardScorecardPoints(null);
            } else {
                this.authService.redirectToSSO(this.userInfo);
            }
        }
    }

    initSubscribe() {
        this._rewardSummaryService.$initPointScorecard.subscribe((data) => {
            if (data) {
                this.initRewardScorecardPoints(data);
            }
        });
    }
    initRewardScorecardPoints(oberveValue) {
        // Call the score card api
        const programType = 'BASEPOINTS';
        //Map the Date to rewards --> rewardPoints, rewardsExpire, rewardsAvailable
        let rwdObj = {
            rewards: {
                balance: 0,
                dollarDiscount: 0,
                points: null,
                autoRewardsPoints:0,
                willExpire:0,
                isUserHasRewards: false
            }
        };

        let profileObj = {
            freshPass: {
                // Fresh Pass check
                isActive: false
            }
        };

        this._rewardSummaryService.getRewardsScoreCardV3(this.currentEnvironment, programType, this.userInfo).subscribe((data: any) => {
            if (data && data.scorecards && data.scorecards.length > 0) {
                // Get the BASEPOINT scorecard
                let scoreCard = data.scorecards.find(scorecard => {
                    return scorecard.programType === 'BASEPOINTS';
                });
                if (scoreCard) {
                    rwdObj.rewards.balance = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                    rwdObj.rewards.points = scoreCard.points;
                    rwdObj.rewards.dollarDiscount = ((scoreCard.dollarDiscount < 0) ? 0 : scoreCard.dollarDiscount);
                    rwdObj.rewards.autoRewardsPoints = ((scoreCard.autoRewardsPoints < 0) ? 0 : scoreCard.autoRewardsPoints);
                    rwdObj.rewards.willExpire = ((scoreCard.willExpire < 0) ? 0 : scoreCard.willExpire);
                    rwdObj.rewards.isUserHasRewards = true;
                }
                // Getting the Profile to see if the user has Fresh Pass.
                this._rewardSummaryService.getFreshpassSubscription(this.currentEnvironment, this.userInfo).subscribe((data: any) => {
                    if (data && data.Data) {
                        this.loading = false;
                        this.showScoreCard = true;
                        profileObj.freshPass.isActive = (data.Data.subscriptionStatus === 'ACTIVE' || data.Data.subscriptionStatus === 'TRIAL' || data.Data.subscriptionStatus === 'PENDING_CANCELLATION');
                        this.freshPassUser = (data.Data.subscriptionStatus === 'ACTIVE' || data.Data.subscriptionStatus === 'TRIAL' || data.Data.subscriptionStatus === 'PENDING_CANCELLATION');
                        this.suspendedFreshPassUser = (data.Data.subscriptionStatus === 'SUSPENDED');
                        this.updateScoreCard(rwdObj, this.freshPassUser);
                    }
                }, error => {
                    this.loading = false;
                    this.showScoreCard = true;
                    profileObj.freshPass.isActive = false;
                    this.freshPassUser = false;
                    this.suspendedFreshPassUser = false;
                    this.updateScoreCard(rwdObj, this.freshPassUser);
                });
                const combinedObj = $.extend({}, rwdObj, profileObj);
                this.rewardsResponseObj = combinedObj;
                this.showScoreCard = true;
                localStorage.setItem('scoreCardDetails', JSON.stringify(combinedObj));
                if(oberveValue) {
                    this._rewardSummaryService.$updateGalleryDetails.next(oberveValue);
                }
                this.refreshAutoCashRewrdSection(oberveValue);
            } else {
                this.loading = false;
                this.showScoreCard = true;
                profileObj.freshPass.isActive = false;
                this.freshPassUser = false;
                this.suspendedFreshPassUser = false;
                const combinedObj = $.extend({}, rwdObj, profileObj);
                this.rewardsResponseObj = combinedObj;
                this.updateScoreCard(rwdObj, this.freshPassUser);
                localStorage.setItem('scoreCardDetails', JSON.stringify(combinedObj));
                if(oberveValue) {
                    this._rewardSummaryService.$updateGalleryDetails.next(oberveValue);
                }
                this.refreshAutoCashRewrdSection(oberveValue);
            }
            if(this.isPointsForServicesActive) {
                if(localStorage.getItem('abRewards') && JSON.parse(localStorage.getItem('abRewards')).cashOffer) {
                    const cashReward = JSON.parse(localStorage.getItem('abRewards')).cashOffer;
                    if(cashReward && cashReward.length > 0 && cashReward[0].status === 'C') {
                        this.openPointsTab('boostYourPoints');
                    } else if(this.isBoostYourPointsActive) {
                        this.openPointsTab('boostYourPoints');
                    } else if(this.ismoreWaysToUseActive) {
                        this.openPointsTab('moreWaysToUse');
                    } else  {
                        this.openPointsTab('rewards');
                    }
                }
            }
        }, error => {
            this.loading = false;
            this.loading = false;
            this.showScoreCard = true;
            profileObj.freshPass.isActive = false;
            this.freshPassUser = false;
            this.suspendedFreshPassUser = false;
            const combinedObj = $.extend({}, rwdObj, profileObj);
            this.rewardsResponseObj = combinedObj;
            this.updateScoreCard(rwdObj, this.freshPassUser);
            localStorage.setItem('scoreCardDetails', JSON.stringify(combinedObj));
            if(oberveValue) {
                this._rewardSummaryService.$updateGalleryDetails.next(combinedObj);
            }
            this.refreshAutoCashRewrdSection(oberveValue);
            if(this.isPointsForServicesActive) {
                if(localStorage.getItem('abRewards') && JSON.parse(localStorage.getItem('abRewards')).cashOffer) {
                    const cashReward = JSON.parse(localStorage.getItem('abRewards')).cashOffer;
                    if(cashReward && cashReward.length > 0 && cashReward[0].status === 'C') {
                        this.openPointsTab('boostYourPoints');
                    } else if(this.ismoreWaysToUseActive) {
                        this.openPointsTab('moreWaysToUse');
                    } else  {
                        this.openPointsTab('rewards');
                    }
                }
            }
        })

    }

    refreshAutoCashRewrdSection(observeValue) {
        if(observeValue) {
            this._rewardSummaryService.$refreshCashRewardSection.next(true);
        }

    }

    updateScoreCard(rwdObj, freshPassUser) {
        this.balanceDisplay = rwdObj.rewards.balance > 0 ? rwdObj.rewards.balance.toLocaleString("en-US") + ' Points' : 'Shop & earn';
        if(rwdObj.rewards.balance > 0) {
            if (rwdObj.rewards.isUserHasRewards && rwdObj.rewards.willExpire >= 0) {
                const dateAsOf = new Date();
                let displayDate = new Date(dateAsOf.getFullYear(), dateAsOf.getMonth() + 1, 0);
                const pointsValue = rwdObj.rewards.willExpire == 1 ? rwdObj.rewards.willExpire.toLocaleString("en-US") + ' Point' : rwdObj.rewards.willExpire.toLocaleString("en-US") + ' Points';
                const expireText = rwdObj.rewards.willExpire == 1 ? ' expires ' : ' expire ';
                this.rewardsPointsValueDetailsDisplay = '<span class="expire-points-value">' + pointsValue + '</span>'
                this.rewardsPointsDateDetailsDisplay = this.rewardsPointsValueDetailsDisplay + expireText + displayDate.toLocaleString('default', {month: 'short'}) + ' ' + displayDate.getDate();
            } else {
                if (!this.isFuelSiteBanner) {
                    this.rewardsPointsDateDetailsDisplay = 'Earn points towards free products and cash off. <a class="start-earning" href="/freshpass/manage/subscribe" target="_parent">Start earning</a>';
                } else {
                    this.rewardsPointsDateDetailsDisplay = 'Earn points towards free products, discounts on gas and cash off. <a class="start-earning" href="/freshpass/manage/subscribe" target="_parent">Start earning</a>';
                }

            }
            if(freshPassUser) {
                this.rewardsPointsDateDetailsDisplay = '';
            }
        } else {
            if (!this.isFuelSiteBanner) {
                this.rewardsPointsDateDetailsDisplay = 'Earn points towards free products and cash off. <a class="start-earning" href="/freshpass/manage/subscribe" target="_parent">Start earning</a>';
            } else {
                this.rewardsPointsDateDetailsDisplay = 'Earn points towards free products, discounts on gas and cash off. <a class="start-earning" href="/freshpass/manage/subscribe" target="_parent">Start earning</a>';
            }
        }


    }

    updateFreshPassComponents(isFreshPassActive) {
        const helpingButtons = $('.helping-link-buttons');
        if (isFreshPassActive && helpingButtons.length > 0) {
            helpingButtons.children('#howForUWorksBanner').removeClass('col-md-6');
            helpingButtons.children('#freshPassBanner').addClass('d-none');
        }
    }

    changeToggleStatus(value) {
        if (value) {
            this.showProgressBar = false;
            if(this.isPointsForServicesActive) {
                this.showBoostPointsHeading = true;
                this.openPointsTab('boostYourPoints');
                this.popupText = 'Clip to boost your Points.';
                this.analyticsAutoCash = 'on';
                $('.coach-mark-container').addClass('bst-points');
            }

        } else {
            this.showProgressBar = true;
            if(this.isPointsForServicesActive) {
                this.showBoostPointsHeading = false;
                this.openPointsTab('rewards');
                this.popupText = 'Check out the new ways to earn and use your Points!';
                this.analyticsAutoCash = 'off';
                $('.coach-mark-container').removeClass('bst-points');
            }
        }
    }
    renderGallery(value) {
        if (value) {
            this.showPointsGallery = true;
        } else {
            this.showPointsGallery = false;
        }
    }

    openRewardsHistory() {
        this.setAnalyticsLinkClick('points-history', 'topNav');
        this.router.navigate(['rewards/points-history']);
    }
    openGetYourRewards() {
        this.setAnalyticsLinkClick('get-your-rewards', 'topNav');
        this.router.navigate(['rewards/get-your-rewards']);
    }

    openProgramDetails() {
        this.setAnalyticsLinkClick('how-it-works', 'topNav');
        window.location.href ='/foru/program-details.html';
    }

    openFreshpass() {
        window['AB']['DATALAYER'].setLinkClickEvents('rewards_never_expires_freshpass');
        window.open('/freshpass/manage/subscribe','_blank')
    }

    refreshRewardScoreCard(value) {
        if (value) {
            this.initRewardScorecardPoints(false);
        }
    }
    public setAnalyticsLinkClick(linkName, analyticsEvent, event?) {
        const sendEvent = linkName !== 'start-earning' || (linkName === 'start-earning' && event?.target.classList.contains('start-earning'));
        if (this.AB && this.AB.DATALAYER && sendEvent) {
            const updatedLinkName = analyticsEvent === 'topNav' ? `cta:${this.AB.DATALAYER.pathSections?.filter((x)=>{return x})?.join(':')}|link|${linkName === 'get-your-rewards' ? '' : 'rewards:'}${linkName}` : linkName;
            if (linkName === 'get-fresh-pass') {
                localStorage.setItem('analyticsGetFreshPass', updatedLinkName);
            } else {
                this.AB.DATALAYER.handleModalAndLinkEvents({modalAndLinkData : updatedLinkName, eventType : analyticsEvent});
            }
        }
    }

    setFuelSiteLink(){
        this.setAnalyticsLinkClick('rewards|rewards-save-at-the-pump', 'linkClick');
        let domain = document.location.host;
        let pattern = /^[^\.]+\./;
        let newDomain = domain.replace(pattern,"local.");
        let newURL = "https://" + newDomain + '/search.html';
        return window.open(newURL,'_blank');
    }

    openPointsTab(pageName: string) {
        var i, tabcontent;
        tabcontent = $('.tabcontent');
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        document.getElementById(pageName).style.display = "block";
        if(pageName === 'rewards') {
            this.isRewardsTabActive = true;
            this.ismoreWaysToUseActive = false;
            this.isBoostYourPointsActive = false;
        } else if(pageName === 'moreWaysToUse') {
            this.isRewardsTabActive = false;
            this.ismoreWaysToUseActive = true;
            this.isBoostYourPointsActive = false;
        } else if(pageName === 'boostYourPoints') {
            this.isRewardsTabActive = false;
            this.ismoreWaysToUseActive = false;
            this.isBoostYourPointsActive = true;
        } else {
            this.isRewardsTabActive = true;
            this.ismoreWaysToUseActive = false;
            this.isBoostYourPointsActive = false;
        }
    }
    handleKeydown(event: KeyboardEvent, page: string) {
        const tabs = this.tabsList.nativeElement.querySelectorAll('[role="tab"]');
        const index = Array.prototype.indexOf.call(tabs, event.target);
        let newIndex = -1;

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (index + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                newIndex = (index - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                newIndex = 0;
                break;
            case 'End':
                newIndex = tabs.length - 1;
                break;
            case 'Enter':
            case ' ':
                this.openPointsTab(page);
                return;
            default:
                return;
        }
        tabs[newIndex].focus();
        event.preventDefault();
    }

    public checkAllowedBanner() {
        if(this.selectedBanner === 'haggen') {
            return false;
        } else if( this.selectedBanner === 'andronicos') {
            return false;
        } else {
            return true;
        }
    }

    public checkFuelAllowedBanner() {
        return this.isFuelSiteBanner;
    }

    public analyticsPageLoad(tabClicked: string) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            localStorage.setItem('analyticsTabClicked', tabClicked);
        }
    }
}
